import { useEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { observer } from 'mobx-react';
import { ROUTE_LOADING_TYPE } from '@constants/index';
import { useDataProvider } from '../../providers/DataProvider';
import RouteLoading from './RouteLoading';
import { useLocalization } from '../../providers/LocalizationProvider';
import { useStore } from '../../providers/MobxProvider';

function RouteRBACCheck({ children }) {
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get, getApiUrl } = useDataProvider(provider);
  const { formatMessage } = useLocalization();
  const { showBoundary } = useErrorBoundary();
  const [isCheckingRBAC, setIsCheckingRBAC] = useState(true);
  const [hasValidRBAC, setHasValidRBAC] = useState(false);
  const store = useStore();

  useEffect(() => {
    async function checkAccess() {
      let userAccess = null;
      const accessDetermined = store.domain.userAccess.get();

      if (!accessDetermined?.company) {
        const accessFound = await get(`${getApiUrl()}/sxcl/v1/me`);
        if (accessFound.ok && accessFound?.data) {
          store.domain.userAccess.set({
            ...accessFound.data,
          });
          userAccess = accessFound.data;
        } else {
          showBoundary({
            message: formatMessage({
              id: 'USER_PERMISSION_NOT_FOUND',
              defaultMessage: 'User permissions not found',
            }),
          });
        }
      } else {
        userAccess = accessDetermined;
      }

      const hasAccess = !!userAccess?.company?.companyType;

      setIsCheckingRBAC(false);
      setHasValidRBAC(hasAccess);

      if (!hasAccess) {
        showBoundary({
          message: formatMessage({
            id: 'COULD_NOT_DETERMINE_USER_PERMISSIONS',
            defaultMessage: 'Could not determine user permissions',
          }),
        });
      }
    }
    checkAccess();
  }, []);

  if (isCheckingRBAC) {
    return <RouteLoading type={ROUTE_LOADING_TYPE.ROUTE_PERMISSION_CHECK} />;
  }

  if (hasValidRBAC) return children;

  return null;
}

export default observer(RouteRBACCheck);
